import 'jquery-ui-bundle';
import 'webpack-jquery-ui/autocomplete';
import url from 'url';

(($) => {
    $.extend($.ui.autocomplete.prototype, {
        _renderItem: (ul, item) => $('<li></li>')
            .data('item.autocomplete', item)
            .append($(`<a href="${item.link}" class="autocomplete-link"></a>`).html(
                `<span class="col-2">${item.tickerSymbol}</span> <span class="col">${item.value}</span> <span class="col-2">(${item.marketGroup})</span>`,
            ))
            .appendTo(ul),
    });

    function dropDown(marketSearch) {
        marketSearch.autocomplete({
            position: { my: 'right top+10', at: 'right+30 bottom' },
            source: function (_request, response) {
                if (marketSearch.val().length > 1) {
                    const sourceUrl = marketSearch.data('sourceurl');
                    marketSearch.closest('.input-group').find('.input-group-prepend .input-group-text').addClass('input-loading');

                    $.get(`${sourceUrl}?s=${marketSearch.val()}`)
                        .done(function (resp) {
                            var res = JSON.parse(resp);
                            if(res && res.length){
                                const sourceList = [];
                                res.forEach((source) => {
                                    const instrumentId = source.instrumentId.replace('.', '-').toLowerCase();
                                    sourceList.push({
                                        tickerSymbol: source.tickerSymbol,
                                        instrumentId,
                                        value: source.name,
                                        marketGroup: source.marketGroup,
                                        label: `${source.instrumentId} ${source.name} ${source.marketGroup}`,
                                        link: url.resolve(sourceUrl, instrumentId),
                                    });
                                });

                                $('.input-group-prepend .input-group-text').removeClass('input-loading');

                                response(sourceList);
                            }

                        }).fail(function(error){
                        console.warn(`Error fetching market search data (${sourceUrl}):`, error);
                        marketSearch.closest('.input-group').find('.input-group-prepend .input-group-text').removeClass('input-loading');
                        marketSearch.prop('disabled', 'disabled');
                        marketSearch.closest('.form-group').addClass('form-group-disabled');
                    });
                }
            },
            minLength: 2,
        });
    }

    const marketSearch = $('.marketsearch-autocomplete');
    marketSearch.val('');

    marketSearch.autocomplete({
        select: function( event, ui ) {
            return window.location = window.location.origin + ui.item.link
        }
    });

    marketSearch.keydown(function(event) {
        //Enter button pressed
        if(event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });

    dropDown(marketSearch);

    marketSearch.change(function () {
        dropDown(marketSearch);
    });

    $(window).resize(function () {
        $('.ui-autocomplete').hide();
    });

    // eslint-disable-next-line no-undef
})(jQuery);
